import { sendItemApiDataEvent } from '../messages/send-item-api-data-event'

export default async function eventItemOpenProcessedHandler() {
  await sendItemApiDataEvent()
}
